<p>
  <img src="/assets/images/icons/chatbot-spinner-solid.svg" class="mt-2 typing-spinner"
       alt="chatbot chat spinner" style="width: 10px; height: 10px;">
</p>
